import { render } from "./PlanModules.vue?vue&type=template&id=28bcaa40&scoped=true"
import script from "./PlanModules.vue?vue&type=script&lang=js"
export * from "./PlanModules.vue?vue&type=script&lang=js"

import "./PlanModules.vue?vue&type=style&index=0&id=28bcaa40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bcaa40"]])

export default __exports__